import { api } from "./apiClient";

export const marketService = {
  categories: async () => (await api.get("/market/categories")).data,
  assets: async (params = {}) => (await api.get("/market/assets", { params })).data,
  toggleFavorite: async (assetId) => (await api.post(`/market/favorites/${assetId}`)).data,
};

export const tradingService = {
  summary: async () => (await api.get("/trading/summary")).data,
  open: async () => (await api.get("/trading/positions")).data,
  pending: async () => (await api.get("/trading/positions/pending")).data,
  closed: async () => (await api.get("/trading/positions/closed")).data,
  order: async (payload) => (await api.post("/trading/orders", payload)).data,
  close: async (id) => (await api.post(`/trading/positions/${id}/close`, {})).data,
};
